<template>
    <div :style="style" ref="lavContainer"></div>
</template>

<script>
  import lottie from 'lottie-web';
  import * as animationData from '../../data.json';
  export default {
    name: 'PrintLoading',
    data () {
      return {
        style: {
          width: '190px',
          height: '70px',
          overflow: 'hidden',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          'border-radius': '8px',
          'background-color': 'rgba(0, 0, 0, 0.7)',
          'z-index': 2064
        }
      }
    },
    mounted () {
      this.anim = lottie.loadAnimation({
          container: this.$refs.lavContainer,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData
        }
      );
    }
  }
</script>